"use client";
import MuiRadioGroup, {
  type RadioGroupProps as MuiRadioGroupProps,
} from "@mui/material/RadioGroup";
import FormFieldWrapper, {
  type FormFieldWrapperProps,
} from "@/components/common/formElements/library/FormFieldWrapper";

export interface RadioGroupProps
  extends MuiRadioGroupProps,
    Pick<
      FormFieldWrapperProps,
      | "label"
      | "helperText"
      | "errorMessage"
      | "required"
      | "error"
      | "fullWidth"
      | "inline"
      | "tooltip"
    > {}

export default function RadioGroup(props: RadioGroupProps) {
  const {
    children,
    required,
    error,
    fullWidth,
    inline,
    label,
    helperText,
    errorMessage,
    tooltip,
    ...radioGroupProps
  } = props;

  return (
    <FormFieldWrapper
      label={label}
      helperText={helperText}
      error={error}
      errorMessage={errorMessage}
      required={required}
      fullWidth={fullWidth}
      inline={inline}
      tooltip={tooltip}
      testId="radio-group"
    >
      <MuiRadioGroup {...radioGroupProps}>{children}</MuiRadioGroup>
    </FormFieldWrapper>
  );
}
